import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
} from "@mui/material";
import { ReactElement } from "react";

export const ConfirmDialog = ({
  title,
  contentText,
  cancelButton,
  confirmButton,
  onClose,
  isOpen,
}: {
  title: string;
  contentText: ReactElement | string;
  cancelButton: ReactElement;
  confirmButton: ReactElement;
  onClose: () => void;
  isOpen: boolean;
}) => {
  const dialogId = `${Math.random()}`;
  const titleId = `alert-dialog-title-${dialogId}`;
  const descriptionId = `alert-dialog-title-${dialogId}`;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
    >
      <DialogTitle id={titleId}>{title}</DialogTitle>
      <DialogContent>
        {/* Use 'div' component because contentText is Typography and you can't have nested <p> elements */}
        <DialogContentText id={descriptionId} component="div">
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Grid container>
          <Grid item flexGrow={1}>
            {cancelButton}
          </Grid>
          <Grid item justifyContent="right">
            {confirmButton}
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
